import { render, staticRenderFns } from "./PageProjects.vue?vue&type=template&id=7465b7e6&scoped=true&"
import script from "./PageProjects.vue?vue&type=script&lang=js&"
export * from "./PageProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7465b7e6",
  null
  
)

export default component.exports